<div class="p-6 md:p-12 lg:py-20 w-full lg:max-w-8xl mx-auto relative">
    <img src="assets/landing-new/icons/highlighter.svg" class="animate-float mx-auto" alt="">
    <img src="assets/landing-new/icons/star-lg.svg"
        class="hidden xl:block xl:absolute animate-blink top-40 left-32 w-16 h-16" alt="">
    <img src="assets/landing-new/icons/star-sm.svg"
        class="hidden xl:block xl:absolute animate-blink top-20 right-32 w-8 h-8" alt="">
    <div class="py-8 lg:py-16 space-y-6 lg:space-y-12">
        <div class="grid grid-cols-12 gap-4" data-aos="fade-up" data-aos-delay="200">
            <div class="col-span-12">
                <p
                    class="max-w-3xl mx-auto text-lg md:text-2xl xl:text-4xl mi--font-regular font-normal text-white leading-normal lg:!leading-[1.16] text-center title-crypto">
                    Launch a crypto project with <br />
                    zero lines of code
                </p>
            </div>
        </div>
        <div class="grid grid-cols-12 gap-4 relative" data-aos="fade-up" data-aos-delay="900" data-aos-duration="1000">
            <div class="col-span-12 md:col-span-4" data-aos="fade-up" data-aos-delay="300">
                <img src="assets/landing-new/images/launch-crypto/connect-wallet.svg" class="mx-auto" alt="">
                <div class="text-center p-6">
                    <h4 class="text-white text-sm lg:text-base ep--font-bold">1. Token Solutions</h4>
                    <p class="text-[#D9D9D9] text-sm lg:text-base ep--font-light pt-3">Create tokens, launchpads, airdrops tokens, and much more with ready-built modules.</p>
                </div>
            </div>
            <img src="assets/landing-new/icons/connect-line.svg" class="hidden xl:block xl:absolute top-12 left-1/4"
                alt="">
            <div class="col-span-12 md:col-span-4" data-aos="fade-up" data-aos-delay="400">
                <img src="assets/landing-new/images/launch-crypto/exchange-token.svg" class="mx-auto" alt="">
                <div class="text-center p-6">
                    <h4 class="text-white text-sm lg:text-base ep--font-bold">2. NFT Solutions</h4>
                    <p class="text-[#D9D9D9] text-sm lg:text-base ep--font-light pt-3">Build an NFT project without writing a single line of code. Drop NFT, fundraise, and much more.</p>
                </div>
            </div>
            <img src="assets/landing-new/icons/connect-line.svg" class="hidden xl:block xl:absolute top-12 right-1/4"
                alt="">
            <div class="col-span-12 md:col-span-4" data-aos="fade-up" data-aos-delay="500">
                <img src="assets/landing-new/images/launch-crypto/start-listing.svg" class="mx-auto" alt="">
                <div class="text-center p-6">
                    <h4 class="text-white text-sm lg:text-base ep--font-bold">3. DeFi Solutions</h4>
                    <p class="text-[#D9D9D9] text-sm lg:text-base ep--font-light pt-3">Access DeFi tools to run your web3 project and build a community with BX Finance No-code.</p>
                </div>
            </div>
        </div>
    </div>
    <img src="assets/landing-new/icons/highlighter.svg" class="animate-float mx-auto" alt="">
</div>
